import { Component, OnInit } from '@angular/core';
import { Product } from 'src/app/order/models/product.model';
import { ProductValidatorService } from '../../validators/product-validator.service';
import { ProductService, costOrNull } from '../../services/product.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-product-new',
    templateUrl: './product-new.component.html',
    styleUrls: ['./product-new.component.scss'],
    standalone: false
})
export class ProductNewComponent implements OnInit {


  product: Product = new Product();

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private productValidator: ProductValidatorService,
    private productService: ProductService) { }

  ngOnInit(): void {
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if(this.productValidator.isValid(this.product)) {

      // A product is always created unpriced: the create route refuses any cost, 0
      // included, because pricing a product is an audited change and there is no id to
      // hang the history entry off until the row exists. So the figure is applied
      // straight after, through the cost route.
      const requestedCost = costOrNull(this.product.cost);
      const payload: Product = Object.assign(new Product(), this.product, {cost: null});

      // try to save it
      this.productService.createProduct(payload)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe((created: Product) => {
        if(requestedCost !== null && created && created.id > 0) {
          this.saveCost(created.id, requestedCost);
        } else {
          window.location.href = '/quoting/products';
        }
      })
    } else {
      this.isError = true;
    }
  }

  /**
   * Prices the product that has just been created.
   *
   * The product exists either way, so a failure here leaves it saved unpriced
   * rather than losing it. Sending the operator to the edit screen instead of the list
   * puts them where they can retry the cost without retyping everything else.
   */
  private saveCost(id: number, cost: number | null): void {
    this.productService.setProductCost(id, cost, 'Set when the product was created')
    .pipe(take(1))
    .pipe(catchError((e) => {
      this.isServerError = true;
      window.location.href = '/quoting/products/edit/' + id;
      return e;
    }))
    .subscribe(() => {
      window.location.href = '/quoting/products';
    })
  }


}
